import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import cache from '../cache/index.js'
import {
	getGameJsonUrl
} from '../api/index.js'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		gameData: {}
	},
	getters: {},
	mutations: {
		setGameData(state, data) {
			state.gameData = data;
		}
	},
	actions: {
		async initGameData({
			commit
		}) {
			try {
				const response = await axios.get(getGameJsonUrl(cache.getGameCode()));
				let game = response.data;
				commit('setGameData', game);
				return game;
			} catch (error) {
				const response = await axios.get(getGameJsonUrl('default'));
				let game = response.data;
				commit('setGameData', game);
				console.error('Failed to fetch game data:', error);
				return game;
			}
		}
	},
	modules: {


	}
})
